import API from '../api';

// function to get single invitation data
export const getInvitation = async (key: string | undefined) => {
  let response = await API.get(`/user/invitations/${key}`);
  return response.data;
}